module.exports = __webpack_public_path__ + "img/job-phone-bg.f7ce8007.png";